import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { obterInformacoesBanner, obterInformacoesBannerRL } from '../../api/mensagemAPI';
import { RootState } from '../../app/store';
import { authLogout } from '../../auth/authSlice';
import { perfilUpdated } from '../../features/Perfil/perfilSlice';

export enum TipoMensagemBanner {
  FAMILIA_FORMADA_1_PESSOA = 1,
  FAMILIA_SEM_REGISTRO_CIVIL = 2,
  FAMILIA_EM_CADASTRAMENTO = 3,
  FAMILIA_ATUALIZADA = 4,
  FAMILIA_FICARA_DESATUALIZADA = 5,
  FAMILIA_ESTA_DESATUALIZADA = 6,
  FAMILIA_ESTA_AVERIGUACAO_RENDA_E_COMPOSICAO_FAMILIAR = 7,
  FAMILIA_ESTA_AVERIGUACAO_DE_COMPOSICAO_FAMILIAR = 8,
  FAMILIA_ESTA_DIFERENTE_OUTRAS_BASES_GOVERNO = 9,
  FAMILIA_CADASTRO_DESATUALIZADO_INCLUIDO_REVISAO_CADASTRAL = 10,
  FAMILIA_POSSUI_PELO_MENOS_2_PENDENCIAS = 11,
  INTEGRANTE_INDICATIVO_OBITO_MAIS_INFORMACOES = 12,
  RF_INDICATIVO_OBITO_REGULAR_PENDENCIA = 13,
  FAMILIA_SEM_RF = 14,
	FAMILIA_COM_MAIS_DE_UM_RF = 15,

}

export interface BannerInfo {
  tipoMensagemBanner: { codigo: TipoMensagemBanner };
  mensagemDetalhe: any;
}

export interface DadosBasicosState {
  bannerInfo: BannerInfo | null;
  bannerInfoLastApiCall: number | null;
  recarregaBanner: number;
}

const initialState: DadosBasicosState = {
  bannerInfo: null,
  bannerInfoLastApiCall: null,
  recarregaBanner: 0
};

export const getBannerInfo = createAsyncThunk<
  BannerInfo,
  { identificador?: any; nuFamiliar?: any; isGovBr: boolean }
>('perfil/getBannerInfo', async (arg, { getState }) => {
  const state = (getState() as RootState).dadosBasicos;

  // Se fizer menos de 5 minutos que a API de informações do banner foi chamada,
  // retorna diretamente a informação atual que está no state.
  if (
    state.bannerInfo &&
    state.bannerInfoLastApiCall &&
    state.bannerInfoLastApiCall > moment().add(-5, 'minutes').valueOf()
  ) {
    return state.bannerInfo;
  }
  if (arg.nuFamiliar) {
    return obterInformacoesBannerRL(arg.nuFamiliar, arg.isGovBr);
  }
  return obterInformacoesBanner(arg.identificador, arg.isGovBr);
});

export const dadosBasicosSlice = createSlice({
  name: 'dadosBasicos',
  initialState,
  reducers: {
    // Chamada utilizada para foçar o recarregamento do banner no componente DadosBasicos
    // como, por exemplo, na exclusão de um integrante por óbito
    recarregarBanner: (state) => {
      state.recarregaBanner = initialState.recarregaBanner + 1;
      state.bannerInfoLastApiCall  = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBannerInfo.fulfilled, (state, action) => {
      state.bannerInfo = action.payload;
      state.bannerInfoLastApiCall = moment().valueOf();
    });
    builder.addCase(authLogout.fulfilled, (state, action) => {
      // Ao realizar logout, resetar bannerInfoLastApiCall
      state.bannerInfoLastApiCall = initialState.bannerInfoLastApiCall;
    });
    builder.addCase(perfilUpdated, (state, action) => {
      // Ao mudar perfil, resetar bannerInfoLastApiCall
      state.bannerInfoLastApiCall = initialState.bannerInfoLastApiCall;
    });
  }
});

export const { recarregarBanner } = dadosBasicosSlice.actions;

export const selectBannerInfo = (state: RootState) => state.dadosBasicos.bannerInfo;
export const selectRecarregaBanner = (state: RootState) => state.dadosBasicos.recarregaBanner;

export default dadosBasicosSlice.reducer;
